"use client";

import { ActivityButton } from "components/ui/Button/ActivityButton";
import { Card } from "components/ui/Card";
import { CardSection } from "components/ui/Card/CardSection";
import { ErrorBlock } from "components/ui/ErrorBlock";
import { H2 } from "components/ui/H";
import { InputField } from "components/ui/InputField";
import { Stack } from "components/ui/Stack";
import { TextField } from "components/ui/TextField";
import { usePasswordResetRequestForm } from "../hooks/usePasswordResetRequestForm";

export const PasswordResetRequestFormCard = () => {
  const { form, errorMessage, submitStatus, isFormValid, sent, handleSubmit } =
    usePasswordResetRequestForm();

  const {
    register,
    formState: { errors },
    getValues,
  } = form;

  const email = getValues("email");

  return (
    <div className="mr-auto ml-auto w-96 text-center">
      <form onSubmit={handleSubmit}>
        <Card>
          <CardSection>
            <Stack spacing="xl">
              <H2>パスワード再設定</H2>
              {errorMessage && <ErrorBlock>{errorMessage}</ErrorBlock>}
              <InputField
                error={errors.email}
                size="xs"
                errorMessageId="password-reset-email-error"
                title={<label htmlFor="password-reset-email">メールアドレス</label>}
                block
              >
                <TextField
                  block
                  type="email"
                  error={errors.email}
                  placeholder="sample@example.com"
                  id="password-reset-email"
                  aria-errormessage="password-reset-email-error"
                  {...register("email", {
                    required: true,
                    setValueAs: (value) => (value as string).trim(),
                  })}
                />
              </InputField>
              {sent && (
                <div
                  role="status"
                  aria-live="polite"
                  className="w-full text-left text-sm leading-relaxed"
                >
                  メールを送信しました。届かない場合は、数分後に迷惑メールフォルダをご確認いただき、再度お試しください。
                  <p className="mt-2">メール内のリンクから新しいパスワードを設定してください。</p>
                  {email && (
                    <div className="text-black56 mt-1 text-xs break-words">送信先: {email}</div>
                  )}
                </div>
              )}
              <ActivityButton
                block
                size="md"
                buttonTheme="primary"
                type="submit"
                working={submitStatus.running}
                disabled={!isFormValid || submitStatus.running}
              >
                メールを送信
              </ActivityButton>
            </Stack>
          </CardSection>
        </Card>
      </form>
    </div>
  );
};
